import { Login } from "@/models/login.model";
import axios from "axios";

class AuthService {
    async authoize(login: string, password: string): Promise<Login> {
        const response = await axios.post<Login>('/auth/login', { login, password })
        if(response.status !== 200){
            throw await Promise.reject(response);
        }
        return response.data;
    }
}

export default new AuthService();